import { createSlice, current } from '@reduxjs/toolkit';
import { ALERTS_IDS } from '../constants/notifierConstants';
import {
  alertInitialState,
  confirmInitialState,
  notifierInitialState,
} from './notifierInitialState';

export const notifierSlice = createSlice({
  name: 'notifier',
  initialState: notifierInitialState,
  reducers: {
    setAlert(state, action) {
      const { id = ALERTS_IDS.wbapp, show } = action.payload;
      const { alert } = current(state);
      state.alert = {
        ...alert,
        [id]: show
          ? { ...alertInitialState, ...action.payload, id }
          : { alertInitialState, id },
      };
    },
    setConfirmOpen(state, action) {
      const { buttons, content, id, title } = action.payload;
      state.confirm[id].buttons = buttons || confirmInitialState.buttons;
      state.confirm[id].content = content;
      state.confirm[id].title = title;
      state.confirm[id].isOpened = true;
      state.confirm[id].isDeclined = false;
      state.confirm[id].isConfirmed = false;
    },
    setConfirmed(state, action) {
      const { id } = action.payload;
      state.confirm[id].isConfirmed = true;
      state.confirm[id].isDeclined = false;
      state.confirm[id].isOpened = false;
    },
    setConfirmDecline(state, action) {
      const { id } = action.payload;
      state.confirm[id].isDeclined = true;
      state.confirm[id].isConfirmed = false;
      state.confirm[id].isOpened = false;
    },
    cleanNotifierSlice() {
      return notifierInitialState;
    },
  },
});

export const {
  cleanNotifierSlice,
  setAlert,
  setConfirmOpen,
  setConfirmDecline,
  setConfirmed,
} = notifierSlice.actions;

export default notifierSlice.reducer;
